import React from 'react'

const ConfirmAlert = ({
  open,
  title = 'Confirmation',
  message = "Êtes-vous sûr d'annuler le transfert ?",
  onCancel,
  onConfirm,
}) => {
  if (!open) return null

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50">
      <div className="w-full max-w-md rounded-lg bg-white p-6 shadow-lg">
        
        <h2 className="mb-2 text-lg font-semibold text-gray-800">
          {title}
        </h2>

        <p className="mb-6 text-gray-600">
          {message}
        </p>

        <div className="flex justify-end gap-3">
          <button
            onClick={onCancel}
            className="rounded-md border border-gray-300 px-4 py-2 text-gray-700 hover:bg-gray-100"
          >
            Annuler
          </button>

          <button
            onClick={onConfirm}
            className="rounded-md bg-red-600  px-4 py-2 text-white hover:bg-red-700 "
          >
            OK
          </button>
        </div>

      </div>
    </div>
  )
}

export default ConfirmAlert
